import { createSelector } from 'reselect';
import { selectPageModelData } from '../store/pageModel/selectors';

export const getGTMCode = createSelector(
	selectPageModelData,
	model => model?.analytics?.gtmCode ?? null
);
